import { queryFilter } from 'utils/proptypes';
import base from './baseApi';

const { urls, methods, execute } = base();

type CreateDestinationDto = {
   name: string;
   address: string;
   mapboxId: string;
   mapboxObject?: any;
};

type UpdateDestinationDto = Partial<CreateDestinationDto> & {
   id: string;
};

type DeleteDestinationDto = {
   id: string;
};

type ReorderDestinationsDto = {
   id: string;
   position: number;
}[];

const createDestination = ({ payload, organizationId }: { payload: CreateDestinationDto; organizationId: string }) => {
   const method = methods.POST;

   const url = `${urls.destinations.site.replace(':organizationId', organizationId)}`;

   return execute(method, url, { authorization: true }, payload);
};

const updateDestination = ({
   payload,
   organizationId,
   destinationId,
}: {
   payload: CreateDestinationDto;
   organizationId: string;
   destinationId: string;
}) => {
   const method = methods.PUT;
   const url = `${urls.destinations.site.replace(':organizationId', organizationId)}/${destinationId}`;

   return execute(method, url, { authorization: true }, payload);
};

const deleteDestination = ({ organizationId, destinationId }: { organizationId: string; destinationId: string }) => {
   const method = methods.DELETE;
   const url = `${urls.destinations.site.replace(':organizationId', organizationId)}/${destinationId}`;

   return execute(method, url, { authorization: true });
};

const getDestinations = (params: queryFilter, organizationId: string) => {
   const header = {
      authorization: true,
   };

   const method = methods.GET;
   const url = `${urls.destinations.site.replace(':organizationId', organizationId)}`;
   return execute(method, url, header, params);
};

const getDestinationsForTraveler = (params: queryFilter, organizationId: string) => {
   const header = {
      authorization: true,
   };

   const method = methods.GET;
   const url = `${urls.destinations.traveler.replace(':organizationId', organizationId)}`;
   return execute(method, url, header, params);
};

const reorderDestinations = (payload: { destinations: ReorderDestinationsDto }) => {
   const method = methods.POST;
   const url = urls.destinations.reorder;

   return execute(method, url, { authorization: true }, payload);
};

export { createDestination, getDestinations, updateDestination, deleteDestination, getDestinationsForTraveler, reorderDestinations };

export type { CreateDestinationDto, DeleteDestinationDto, UpdateDestinationDto };
